/*
 * Native Possum — np-product-lightbox-desktop.js
 * Behaviour for snippets/np-product-lightbox-desktop.liquid (see its header).
 * Loaded deferred (it only reacts to clicks / later events).
 */
(function() {
  'use strict';

  /* Set up at every width: the page can rotate or resize into 768px+ after load.
     Opening is only wired to the desktop main image and the tablet carousel. */

  /* --- DOM --- */
  var lightbox = document.getElementById('npDesktopLightbox');
  var img = document.getElementById('npDlbImage');
  var wrapper = document.getElementById('npDlbImageWrapper');
  var counter = document.getElementById('npDlbCounter');
  var closeBtn = document.getElementById('npDlbClose');
  var prevBtn = document.getElementById('npDlbPrev');
  var nextBtn = document.getElementById('npDlbNext');
  var stage = document.getElementById('npDlbStage');
  var hint = document.getElementById('npDlbHint');

  if (!lightbox || !img) return;

  var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  if (isTouch && hint) hint.textContent = 'Pinch to zoom';

  /* --- STATE --- */
  var images = [];
  var cache = {};
  var idx = 0;
  var isOpen = false;
  var zoomed = false;

  /* Zoom overlay */
  var zoomOverlay = null;
  var zoomImg = null;

  /* Mouse drag-to-scroll */
  var dragging = false;
  var dragStartX = 0;
  var dragStartY = 0;
  var dragScrollX = 0;
  var dragScrollY = 0;
  var didDrag = false;

  /* Touch */
  var tStartX = 0;
  var tStartY = 0;
  var tStartTime = 0;
  var tMoved = false;
  var pinching = false;
  var pinchDist = 0;

  /* --- HELPERS --- */
  function stripWidth(url) {
    if (!url) return url;
    return url.replace(/([?&])width=\d+&?/, function(m, p) {
      return p === '?' ? '?' : '';
    }).replace(/[?&]$/, '');
  }

  /* --- DATA --- */
  function extract() {
    if (images.length || !window.npProduct) return;
    images = window.npProduct.data.media.map(function(m) {
      return { url: m.url, full: stripWidth(m.url), fx: m.fx, fy: m.fy };
    });
  }

  function preload(i) {
    if (cache[i] || !images[i]) return;
    var temp = new Image();
    temp.onload = function() {
      cache[i] = { w: temp.naturalWidth, h: temp.naturalHeight, url: images[i].full };
    };
    temp.src = images[i].full;
  }

  /* --- ZOOM --- */
  function zoomIn(cx, cy) {
    var c = cache[idx];
    if (!c) return;

    var dpr = window.devicePixelRatio || 1;
    var fullW = c.w / dpr;
    var fullH = c.h / dpr;

    /* Get click position as fraction of the fitted image */
    var imgRect = img.getBoundingClientRect();

    /* Skip if no meaningful zoom */
    if (fullW <= imgRect.width * 1.05 && fullH <= imgRect.height * 1.05) return;

    var fracX = (cx - imgRect.left) / imgRect.width;
    var fracY = (cy - imgRect.top) / imgRect.height;

    /* Hide the fitted image */
    wrapper.style.visibility = 'hidden';

    /* Create fresh scrollable overlay */
    zoomOverlay = document.createElement('div');
    zoomOverlay.className = 'np-dlb-zoom-overlay';
    if (isTouch) zoomOverlay.classList.add('np-touch-device');

    zoomImg = document.createElement('img');
    zoomImg.src = c.url;
    zoomImg.style.width = fullW + 'px';
    zoomImg.style.height = fullH + 'px';
    zoomImg.alt = img.alt;
    zoomImg.setAttribute('draggable', 'false');

    zoomOverlay.appendChild(zoomImg);
    lightbox.appendChild(zoomOverlay);

    /* Scroll so clicked point stays under cursor */
    var overlayRect = zoomOverlay.getBoundingClientRect();
    zoomOverlay.scrollLeft = (fracX * fullW) - (cx - overlayRect.left);
    zoomOverlay.scrollTop = (fracY * fullH) - (cy - overlayRect.top);

    /* Enter zoom state */
    zoomed = true;
    lightbox.classList.add('is-zoomed');

    /* Attach overlay mouse events */
    zoomOverlay.addEventListener('mousedown', onZoomMouseDown);
    zoomOverlay.addEventListener('click', onZoomClick);

    /* Attach overlay touch events */
    if (isTouch) {
      zoomOverlay.addEventListener('touchstart', onZoomTouchStart, { passive: false });
      zoomOverlay.addEventListener('touchmove', onZoomTouchMove, { passive: false });
      zoomOverlay.addEventListener('touchend', onZoomTouchEnd, { passive: true });
    }
  }

  function zoomOut() {
    if (zoomOverlay) {
      zoomOverlay.removeEventListener('mousedown', onZoomMouseDown);
      zoomOverlay.removeEventListener('click', onZoomClick);
      if (isTouch) {
        zoomOverlay.removeEventListener('touchstart', onZoomTouchStart);
        zoomOverlay.removeEventListener('touchmove', onZoomTouchMove);
        zoomOverlay.removeEventListener('touchend', onZoomTouchEnd);
      }
      lightbox.removeChild(zoomOverlay);
      zoomOverlay = null;
      zoomImg = null;
    }

    wrapper.style.visibility = '';
    zoomed = false;
    dragging = false;
    lightbox.classList.remove('is-zoomed');
  }

  /* --- ZOOM OVERLAY MOUSE EVENTS --- */
  function onZoomMouseDown(e) {
    if (isTouch) return;
    e.preventDefault();
    dragging = true;
    didDrag = false;
    dragStartX = e.clientX;
    dragStartY = e.clientY;
    dragScrollX = zoomOverlay.scrollLeft;
    dragScrollY = zoomOverlay.scrollTop;
    zoomOverlay.classList.add('is-dragging');
  }

  function onZoomClick(e) {
    if (isTouch) return;
    if (didDrag) { didDrag = false; return; }
    zoomOut();
  }

  /* Global mouse handlers for drag continuity outside overlay */
  document.addEventListener('mousemove', function(e) {
    if (!dragging || !zoomOverlay) return;
    var dx = e.clientX - dragStartX;
    var dy = e.clientY - dragStartY;
    if (Math.abs(dx) > 3 || Math.abs(dy) > 3) didDrag = true;
    zoomOverlay.scrollLeft = dragScrollX - dx;
    zoomOverlay.scrollTop = dragScrollY - dy;
  });

  document.addEventListener('mouseup', function() {
    if (!dragging) return;
    dragging = false;
    if (zoomOverlay) zoomOverlay.classList.remove('is-dragging');
  });

  /* --- ZOOM OVERLAY TOUCH EVENTS --- */
  function touchDist(t) {
    var dx = t[0].clientX - t[1].clientX;
    var dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function onZoomTouchStart(e) {
    if (e.touches.length === 1) {
      tStartX = e.touches[0].clientX;
      tStartY = e.touches[0].clientY;
      tStartTime = Date.now();
      tMoved = false;
    }
  }

  function onZoomTouchMove(e) {
    if (e.touches.length === 1) {
      var sx = e.touches[0].clientX - tStartX;
      var sy = e.touches[0].clientY - tStartY;
      if (Math.abs(sx) > 10 || Math.abs(sy) > 10) tMoved = true;
      /* Native scroll handles the actual panning via touch-action CSS */
    }
  }

  function onZoomTouchEnd(e) {
    if (e.changedTouches.length === 1) {
      var elapsed = Date.now() - tStartTime;
      /* Tap to zoom out */
      if (!tMoved && elapsed < 300) {
        zoomOut();
      }
    }
  }

  /* --- UNZOOMED WRAPPER EVENTS --- */

  /* Mouse: click to zoom */
  wrapper.addEventListener('click', function(e) {
    e.stopPropagation();
    if (isTouch || zoomed) return;

    if (cache[idx]) {
      zoomIn(e.clientX, e.clientY);
    } else {
      var data = images[idx];
      if (!data) return;
      var cx = e.clientX, cy = e.clientY;
      var temp = new Image();
      temp.onload = function() {
        cache[idx] = { w: temp.naturalWidth, h: temp.naturalHeight, url: data.full };
        zoomIn(cx, cy);
      };
      temp.src = data.full;
    }
  });

  /* Touch on unzoomed wrapper: pinch to zoom, swipe to navigate, tap to close */
  function onWrapperTouchStart(e) {
    if (!isOpen || zoomed) return;

    if (e.touches.length === 2) {
      e.preventDefault();
      pinching = true;
      tMoved = true;
      pinchDist = touchDist(e.touches);
    } else if (e.touches.length === 1) {
      tStartX = e.touches[0].clientX;
      tStartY = e.touches[0].clientY;
      tStartTime = Date.now();
      tMoved = false;
      pinching = false;
    }
  }

  function onWrapperTouchMove(e) {
    if (!isOpen || zoomed) return;

    if (e.touches.length === 2 && pinching) {
      e.preventDefault();
      tMoved = true;
      var d = touchDist(e.touches);
      if (d > pinchDist * 1.3 && cache[idx]) {
        var mx = (e.touches[0].clientX + e.touches[1].clientX) / 2;
        var my = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        zoomIn(mx, my);
      }
    } else if (e.touches.length === 1 && !pinching) {
      var sx = e.touches[0].clientX - tStartX;
      var sy = e.touches[0].clientY - tStartY;
      if (Math.abs(sx) > 10 || Math.abs(sy) > 10) tMoved = true;
    }
  }

  function onWrapperTouchEnd(e) {
    if (!isOpen) return;
    if (zoomed) return;

    if (pinching) { pinching = false; return; }

    if (e.changedTouches.length === 1) {
      var dx = e.changedTouches[0].clientX - tStartX;
      var dy = e.changedTouches[0].clientY - tStartY;
      var elapsed = Date.now() - tStartTime;

      /* Tap to close */
      if (!tMoved && elapsed < 300) {
        close();
        return;
      }

      /* Swipe to navigate */
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        if (dx < 0) goNext();
        else goPrev();
      }
    }
  }

  if (isTouch) {
    wrapper.addEventListener('touchstart', onWrapperTouchStart, { passive: false });
    wrapper.addEventListener('touchmove', onWrapperTouchMove, { passive: false });
    wrapper.addEventListener('touchend', onWrapperTouchEnd, { passive: true });
  }

  /* --- SHOW IMAGE --- */
  function show(i) {
    if (i < 0 || i >= images.length) return;
    idx = i;

    if (zoomed) zoomOut();

    img.classList.remove('loaded');

    var data = images[idx];
    setTimeout(function() {
      img.src = data.url;
      img.alt = (document.querySelector('.product-title') || {}).textContent || 'Product';
      img.alt += ' \u2014 image ' + (idx + 1) + ' of ' + images.length;
      img.style.objectPosition = data.fx + '% ' + data.fy + '%';

      var onLoad = function() {
        img.classList.add('loaded');
        img.onload = null;
        preload(idx);
        if (idx > 0) preload(idx - 1);
        if (idx < images.length - 1) preload(idx + 1);
      };

      if (img.complete) onLoad();
      else img.onload = onLoad;
    }, 150);

    counter.textContent = (idx + 1) + ' / ' + images.length;
    updateArrows();
  }

  /* --- OPEN / CLOSE --- */
  /* trigger: what opened the viewer — focus returns there on close */
  var openedAt = 0;

  function open(startIdx, trigger) {
    extract();
    if (!images.length) return;
    idx = startIdx || 0;
    openedAt = idx;
    isOpen = true;

    show(idx);
    lightbox.classList.add('active');
    document.body.classList.add('np-desktop-lightbox-open');

    if (hint) {
      hint.classList.remove('hidden');
      window.npMessage.dwell(hint, function() { hint.classList.add('hidden'); });
    }
    /* Shared layer helper: inert page, focus, Escape, focus return */
    if (window.npLayer) {
      window.npLayer.open(lightbox, {
        trigger: trigger,
        initialFocus: lightbox,
        onRequestClose: function() { if (zoomed) zoomOut(); else close(); }
      });
    } else {
      lightbox.inert = false;
      lightbox.focus();
    }
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    if (zoomed) zoomOut();

    lightbox.classList.remove('active');
    lightbox.classList.remove('is-zoomed');
    document.body.classList.remove('np-desktop-lightbox-open');

    if (window.npLayer) window.npLayer.close(lightbox);
    /* Back on the page at the photo they were viewing (it picks its colour) */
    if (idx !== openedAt && window.npProduct) window.npProduct.showMedia(idx);
  }

  window.npDesktopLightboxOpen = open;

  /* --- ARROWS --- */
  /* .hidden keeps the fade; disabled takes the button out of the Tab order */
  function setArrowHidden(btn, hide) {
    btn.classList.toggle('hidden', hide);
    if (hide && document.activeElement === btn) lightbox.focus();
    btn.disabled = hide;
  }

  function updateArrows() {
    if (images.length <= 1) {
      setArrowHidden(prevBtn, true);
      setArrowHidden(nextBtn, true);
      counter.style.display = 'none';
      return;
    }
    counter.style.display = '';
    setArrowHidden(prevBtn, idx === 0);
    setArrowHidden(nextBtn, idx === images.length - 1);
  }

  function goNext() { if (idx < images.length - 1) show(idx + 1); }
  function goPrev() { if (idx > 0) show(idx - 1); }

  function getActiveThumbIdx() {
    var active = document.querySelector('.thumbnail.active');
    if (!active) return 0;
    var all = document.querySelectorAll('.thumbnail');
    for (var i = 0; i < all.length; i++) {
      if (all[i] === active) return i;
    }
    return 0;
  }

  /* --- OTHER LISTENERS --- */
  /* The container's "Enlarge image" button covers it, so mouse clicks and
     Enter/Space both arrive here as a click */
  var mainImg = document.getElementById('mainImageContainer');
  if (mainImg) {
    var enlargeBtn = mainImg.querySelector('.np-main-image-enlarge');
    mainImg.addEventListener('click', function() {
      if (!window.matchMedia('(min-width: 768px)').matches) return;
      open(getActiveThumbIdx(), enlargeBtn || null);
    });
  }

  closeBtn.addEventListener('click', function(e) { e.stopPropagation(); close(); });
  prevBtn.addEventListener('click', function(e) { e.stopPropagation(); goPrev(); });
  nextBtn.addEventListener('click', function(e) { e.stopPropagation(); goNext(); });

  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox || e.target === stage) {
      if (zoomed) zoomOut();
      else close();
    }
  });

  lightbox.addEventListener('keydown', function(e) {
    if (!isOpen) return;
    /* Escape is handled centrally by npLayer (onRequestClose above) */
    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        if (!zoomed) goPrev();
        break;
      case 'ArrowRight':
        e.preventDefault();
        if (!zoomed) goNext();
        break;
    }
  });

})();
